import {QuotationControllerApi } from 'client';
import { RESPONSE_PATH, RESPONSE_VIEW_ERROR } from 'constants/ResponseType';
import { useHistory } from 'react-router-dom';
import { getTokenFromStorage } from 'utils/GetTokenFromStorage';

export const useQuotationServices = () => {
	const token = getTokenFromStorage();
	const history = useHistory();
	const quotationServices = new QuotationControllerApi();

	const errorRedirect = () => {
		history.push(`${RESPONSE_PATH}/${RESPONSE_VIEW_ERROR}/error`);
	};

	const createQuotation = (formData: any, success: Function) => {
		quotationServices
			.createQuotationUsingPOST(token, formData)
			.then((response) => success(response.data))
			.catch((_err) => errorRedirect());
	};

	const getDataFormsFields = (success: Function, tipo_vehiculo: string, marca?: string, modelo?: string, region?: string, comuna?: string, sucursal?: string) => {
		quotationServices
			.getDataFormsFieldsUsingGet(token, tipo_vehiculo, marca, modelo, region, comuna, sucursal)
			.then((response) => success(response.data))
			.catch((_err) => errorRedirect());
	}

	return { createQuotation, getDataFormsFields } as const;
};
